import request from '@/utils/request';

const PATH = '/coupon';

export const registerCoupon = (data: any) => request({
  url: `${PATH}/register`,
  method: 'post',
  data,
});
